import { api } from '../hooks/useConfigureAxios';

type LoginRequest = {
  username: string;
  password: string;
};

type PasswordResetRequest = {
  oldPassword: string;
  newPassword: string;
}

type LoginResponse = {
  accessToken: string;
};

export const AuthAPI = {
  Login: async function (request: LoginRequest) : Promise<LoginResponse> {
    const response = await api.post(
      '/auth',
      request,
    );

    return {
      accessToken: response.data.access_token,
    };
  },
  Reset: async function (request: PasswordResetRequest) : Promise<void> {
    await api.put(
      '/auth/reset',
      request,
    );
  },
};